import React from 'react';
import { Link } from 'react-router-dom';
import * as icons from 'react-icons/lib/md';
import FilterContainer from '../../containers/FilterContainer'
import { Money, Comma } from '../../Utils';

const GasIcon = icons.MdLocalGasStation;
const EditIcon = icons.MdEdit;

export default ({car})=>

<article className="car-container" key={car.label}>
	<Link className="car-label" to={"/entry/cars/"+car.label}><EditIcon/>{car.label}</Link>
	<FilterContainer car={car.label} />
   	<div className="car">
	   	<div className="fuel_economy"><h1>MPG</h1>{car.fuel_economy}</div>
	    <ul>
	    	<li><span className="label">Miles</span> <span>{Comma(car.distance)}</span></li>
	    	<li><span className="label">Gallons</span> <span> {Comma(car.units)}</span></li>
	    	<li><span className="label">Total</span> <span> {Money(car.sub_total)}</span></li>
	    </ul>
	    <Link className="add-fuel" to={"/entry/fuel/"+car.label}><GasIcon/>Add Fuel</Link>
	</div>
</article>


// WEBPACK FOOTER //
// ./src/components/Home/card.js